/*
    Source URI: https://github.com/verlok/vanilla-lazyload.git
*/

var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
});
